import { schema } from 'normalizr';

import { processNetwork } from '../strategies/network';

export const networkSchema: schema.Entity = new schema.Entity('networks', {}, { processStrategy: processNetwork });
